<template>

    <div class="c-entry">

        <div class="c-entry__container o-container">

            <div class="c-entry__content">

                <h2> What SMARTBOW&reg; Could Mean For You</h2>

                <p>There are dozens of things happening on your farm every day. It’s impossible to be everywhere at once. With SMARTBOW, you don’t have to be. Discover what SMARTBOW can mean for you in this interactive experience.</p>

                <button class="e-btn" @click="start">
                    Discover
                    <svg xmlns="http://www.w3.org/2000/svg" width="11.889" height="23.255"><path data-name="Path 4009" d="M11.886 11.539a1.292 1.292 0 00-.331-.775L2.255.429A1.292 1.292 0 10.333 2.157l8.527 9.471-8.527 9.471a1.292 1.292 0 001.922 1.728l9.3-10.335a1.292 1.292 0 00.331-.953z" fill="#fff"/></svg>
                </button>
            
            </div>

            <div class="c-entry__slider-container">

                <div class="c-entry__slider">

                    <h2 class="c-entry__slider-head">CHALLENGES SMARTBOW CAN HELP WITH</h2>
                    
                    <carousel :perPage="1" :navigationEnabled="true" paginationColor="#464647" paginationActiveColor="#FFFFFF" :loop="true">

                        <slide class="c-entry__slide">

                            <div class="c-entry__slide-img">

                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 137.1 97.49"><path data-name="Path 4027" d="M128.65 16.4c-2.55-2.53-5.42-5.39-7.75-8.18-3-3.54-8.79-2.59-12.06-1.69a9.77 9.77 0 00-3.13-4.34A11.66 11.66 0 0096.27.3a2.92 2.92 0 00-1.8 1.39c-1.13 1.93-.67 5.73-.09 7.81a8.42 8.42 0 003.56 4.66 9.48 9.48 0 01-4 1.7c-10.94.82-33.52 1-48.47 1.05-7 .05-12.44.08-15 .17-8.3.28-14.56 2.67-18.64 7.11A18.22 18.22 0 009.73 27C4.53 31.74-1.75 43 .55 56.76c.25 1.5.49 2.91.72 4.22C3.26 72.5 3.67 76 0 79.53l3 3.08c5.46-5.29 4.48-11 2.52-22.36q-.35-2-.72-4.2a31 31 0 011.91-16.9v1.17a98.73 98.73 0 004.8 24.73 248.31 248.31 0 01-.07 29.76 2.14 2.14 0 002 2.3 1 1 0 00.17 0h9.11a2.14 2.14 0 002.14-2l.14-3.26h6.49a2.13 2.13 0 002.14-2.11l.49-18.39a8.61 8.61 0 001.47 1.29 16.24 16.24 0 002 1.19s-.76 2-1.19 3 .48 1.53 1.43 2.2a2.11 2.11 0 002.72-.43 38.11 38.11 0 002.15-3.58h2.81s.33 2.48.43 3.82 1.48 1.67 2.53 1.67c1.28 0 1.86-.29 1.86-1.77s.19-3.57.19-3.57a7.36 7.36 0 002.19-.39 8.4 8.4 0 003-1.24l-5.77-3.62s-.48.57-2.67.85a14.21 14.21 0 01-8-1.67 20 20 0 01-5.59-4.24l.09-4.66a20.23 20.23 0 015.77 1 25.37 25.37 0 017.93 3.45C53.45 69 60.22 75.3 75.28 74c4.67-.42 10.77-.31 13.19 1.66a2.57 2.57 0 011 1.89c.5 6.2 1.14 17.85 1.14 18a2.14 2.14 0 002.14 2h6.8a2.15 2.15 0 002.14-2.13v-2.49c-.24-4-.23-8.16-.22-12.26v-1.3-4.09a24.84 24.84 0 01.93-6.06c.43-1.5 1-3.08 1.63-4.74 1.34-3.63 2.72-7.39 2.53-10.64a44.41 44.41 0 00-1.92-9.41 3.67 3.67 0 01.28-2.83q.39-.74.87-1.53c2-3.31 3.12-3.91 3.34-4 2 .08 16.28.65 20 .33s7.06-5.85 7.67-7.38c1.33-3.21-2.44-6.96-8.15-12.62zM29.33 87.58h-4.2L25.94 63a9.35 9.35 0 013.65-2.16zm99.47-55.45c-2.94.25-14.16-.12-19.68-.35h-.23c-2.15.13-4.26 2-6.63 5.87a51.25 51.25 0 00-2.49 4.69c0 .07 2.55 7 2.83 11.73.14 2.41-1.1 5.77-2.3 9-.61 1.66-1.25 3.37-1.72 5a33.89 33.89 0 00-1.08 10.8v.68l-.08 13.61h-2.64c-.2-3.65-.66-11.38-1-16a6.89 6.89 0 00-2.59-4.86c-4.59-3.73-13.71-3.15-16.4-2.86-12.6 1.34-18.8-4.62-25.35-9a28.82 28.82 0 00-7.8-3.56C28 52.51 22.32 60.25 22.1 60.57a2 2 0 00-.4 1.16l-1.07 31.1h-4.79a255.17 255.17 0 00-.08-28.34 1.87 1.87 0 00-.12-.58A95.68 95.68 0 0111 40.11a19.61 19.61 0 012.09-10.37l.1-.08A13.65 13.65 0 0115 27.07c3.28-3.56 8.54-5.49 15.64-5.73 2.46-.08 7.93-.12 14.84-.16 15-.1 37.68-.24 48.77-1.07 4.32-.33 8.71-4.4 9.2-4.86a2.15 2.15 0 00.06-3 2.06 2.06 0 00-1-.59s-3.38-1-4-3.29a12 12 0 01-.42-4 7.3 7.3 0 015 1.28 6.34 6.34 0 012.1 3.88 2.14 2.14 0 002.91 1.78c3-1.14 8-2 9.5-.29 2.45 3 5.41 5.88 8 8.47 2.87 2.86 6.79 6.74 7.15 8.18-.7 1.61-2.99 4.33-3.95 4.46z" fill="#fff"/></svg>
                        
                            </div>
                            
                            <p>You need to sleep, but SMARTBOW does not. It can detect heats overnight.</p>
                        
                        </slide>

                        <slide class="c-entry__slide">

                            <div class="c-entry__slide-img">

                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 137.1 97.49"><path data-name="Path 4027" d="M128.65 16.4c-2.55-2.53-5.42-5.39-7.75-8.18-3-3.54-8.79-2.59-12.06-1.69a9.77 9.77 0 00-3.13-4.34A11.66 11.66 0 0096.27.3a2.92 2.92 0 00-1.8 1.39c-1.13 1.93-.67 5.73-.09 7.81a8.42 8.42 0 003.56 4.66 9.48 9.48 0 01-4 1.7c-10.94.82-33.52 1-48.47 1.05-7 .05-12.44.08-15 .17-8.3.28-14.56 2.67-18.64 7.11A18.22 18.22 0 009.73 27C4.53 31.74-1.75 43 .55 56.76c.25 1.5.49 2.91.72 4.22C3.26 72.5 3.67 76 0 79.53l3 3.08c5.46-5.29 4.48-11 2.52-22.36q-.35-2-.72-4.2a31 31 0 011.91-16.9v1.17a98.73 98.73 0 004.8 24.73 248.31 248.31 0 01-.07 29.76 2.14 2.14 0 002 2.3 1 1 0 00.17 0h9.11a2.14 2.14 0 002.14-2l.14-3.26h6.49a2.13 2.13 0 002.14-2.11l.49-18.39a8.61 8.61 0 001.47 1.29 16.24 16.24 0 002 1.19s-.76 2-1.19 3 .48 1.53 1.43 2.2a2.11 2.11 0 002.72-.43 38.11 38.11 0 002.15-3.58h2.81s.33 2.48.43 3.82 1.48 1.67 2.53 1.67c1.28 0 1.86-.29 1.86-1.77s.19-3.57.19-3.57a7.36 7.36 0 002.19-.39 8.4 8.4 0 003-1.24l-5.77-3.62s-.48.57-2.67.85a14.21 14.21 0 01-8-1.67 20 20 0 01-5.59-4.24l.09-4.66a20.23 20.23 0 015.77 1 25.37 25.37 0 017.93 3.45C53.45 69 60.22 75.3 75.28 74c4.67-.42 10.77-.31 13.19 1.66a2.57 2.57 0 011 1.89c.5 6.2 1.14 17.85 1.14 18a2.14 2.14 0 002.14 2h6.8a2.15 2.15 0 002.14-2.13v-2.49c-.24-4-.23-8.16-.22-12.26v-1.3-4.09a24.84 24.84 0 01.93-6.06c.43-1.5 1-3.08 1.63-4.74 1.34-3.63 2.72-7.39 2.53-10.64a44.41 44.41 0 00-1.92-9.41 3.67 3.67 0 01.28-2.83q.39-.74.87-1.53c2-3.31 3.12-3.91 3.34-4 2 .08 16.28.65 20 .33s7.06-5.85 7.67-7.38c1.33-3.21-2.44-6.96-8.15-12.62zM29.33 87.58h-4.2L25.94 63a9.35 9.35 0 013.65-2.16zm99.47-55.45c-2.94.25-14.16-.12-19.68-.35h-.23c-2.15.13-4.26 2-6.63 5.87a51.25 51.25 0 00-2.49 4.69c0 .07 2.55 7 2.83 11.73.14 2.41-1.1 5.77-2.3 9-.61 1.66-1.25 3.37-1.72 5a33.89 33.89 0 00-1.08 10.8v.68l-.08 13.61h-2.64c-.2-3.65-.66-11.38-1-16a6.89 6.89 0 00-2.59-4.86c-4.59-3.73-13.71-3.15-16.4-2.86-12.6 1.34-18.8-4.62-25.35-9a28.82 28.82 0 00-7.8-3.56C28 52.51 22.32 60.25 22.1 60.57a2 2 0 00-.4 1.16l-1.07 31.1h-4.79a255.17 255.17 0 00-.08-28.34 1.87 1.87 0 00-.12-.58A95.68 95.68 0 0111 40.11a19.61 19.61 0 012.09-10.37l.1-.08A13.65 13.65 0 0115 27.07c3.28-3.56 8.54-5.49 15.64-5.73 2.46-.08 7.93-.12 14.84-.16 15-.1 37.68-.24 48.77-1.07 4.32-.33 8.71-4.4 9.2-4.86a2.15 2.15 0 00.06-3 2.06 2.06 0 00-1-.59s-3.38-1-4-3.29a12 12 0 01-.42-4 7.3 7.3 0 015 1.28 6.34 6.34 0 012.1 3.88 2.14 2.14 0 002.91 1.78c3-1.14 8-2 9.5-.29 2.45 3 5.41 5.88 8 8.47 2.87 2.86 6.79 6.74 7.15 8.18-.7 1.61-2.99 4.33-3.95 4.46z" fill="#fff"/></svg>
                        
                            </div>
                            
                            <p>No time for heat detection? No problem. SMARTBOW monitors while you go about your day.</p>
                        
                        </slide>

                        <slide class="c-entry__slide">

                            <div class="c-entry__slide-img">

                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 137.1 97.49"><path data-name="Path 4027" d="M128.65 16.4c-2.55-2.53-5.42-5.39-7.75-8.18-3-3.54-8.79-2.59-12.06-1.69a9.77 9.77 0 00-3.13-4.34A11.66 11.66 0 0096.27.3a2.92 2.92 0 00-1.8 1.39c-1.13 1.93-.67 5.73-.09 7.81a8.42 8.42 0 003.56 4.66 9.48 9.48 0 01-4 1.7c-10.94.82-33.52 1-48.47 1.05-7 .05-12.44.08-15 .17-8.3.28-14.56 2.67-18.64 7.11A18.22 18.22 0 009.73 27C4.53 31.74-1.75 43 .55 56.76c.25 1.5.49 2.91.72 4.22C3.26 72.5 3.67 76 0 79.53l3 3.08c5.46-5.29 4.48-11 2.52-22.36q-.35-2-.72-4.2a31 31 0 011.91-16.9v1.17a98.73 98.73 0 004.8 24.73 248.31 248.31 0 01-.07 29.76 2.14 2.14 0 002 2.3 1 1 0 00.17 0h9.11a2.14 2.14 0 002.14-2l.14-3.26h6.49a2.13 2.13 0 002.14-2.11l.49-18.39a8.61 8.61 0 001.47 1.29 16.24 16.24 0 002 1.19s-.76 2-1.19 3 .48 1.53 1.43 2.2a2.11 2.11 0 002.72-.43 38.11 38.11 0 002.15-3.58h2.81s.33 2.48.43 3.82 1.48 1.67 2.53 1.67c1.28 0 1.86-.29 1.86-1.77s.19-3.57.19-3.57a7.36 7.36 0 002.19-.39 8.4 8.4 0 003-1.24l-5.77-3.62s-.48.57-2.67.85a14.21 14.21 0 01-8-1.67 20 20 0 01-5.59-4.24l.09-4.66a20.23 20.23 0 015.77 1 25.37 25.37 0 017.93 3.45C53.45 69 60.22 75.3 75.28 74c4.67-.42 10.77-.31 13.19 1.66a2.57 2.57 0 011 1.89c.5 6.2 1.14 17.85 1.14 18a2.14 2.14 0 002.14 2h6.8a2.15 2.15 0 002.14-2.13v-2.49c-.24-4-.23-8.16-.22-12.26v-1.3-4.09a24.84 24.84 0 01.93-6.06c.43-1.5 1-3.08 1.63-4.74 1.34-3.63 2.72-7.39 2.53-10.64a44.41 44.41 0 00-1.92-9.41 3.67 3.67 0 01.28-2.83q.39-.74.87-1.53c2-3.31 3.12-3.91 3.34-4 2 .08 16.28.65 20 .33s7.06-5.85 7.67-7.38c1.33-3.21-2.44-6.96-8.15-12.62zM29.33 87.58h-4.2L25.94 63a9.35 9.35 0 013.65-2.16zm99.47-55.45c-2.94.25-14.16-.12-19.68-.35h-.23c-2.15.13-4.26 2-6.63 5.87a51.25 51.25 0 00-2.49 4.69c0 .07 2.55 7 2.83 11.73.14 2.41-1.1 5.77-2.3 9-.61 1.66-1.25 3.37-1.72 5a33.89 33.89 0 00-1.08 10.8v.68l-.08 13.61h-2.64c-.2-3.65-.66-11.38-1-16a6.89 6.89 0 00-2.59-4.86c-4.59-3.73-13.71-3.15-16.4-2.86-12.6 1.34-18.8-4.62-25.35-9a28.82 28.82 0 00-7.8-3.56C28 52.51 22.32 60.25 22.1 60.57a2 2 0 00-.4 1.16l-1.07 31.1h-4.79a255.17 255.17 0 00-.08-28.34 1.87 1.87 0 00-.12-.58A95.68 95.68 0 0111 40.11a19.61 19.61 0 012.09-10.37l.1-.08A13.65 13.65 0 0115 27.07c3.28-3.56 8.54-5.49 15.64-5.73 2.46-.08 7.93-.12 14.84-.16 15-.1 37.68-.24 48.77-1.07 4.32-.33 8.71-4.4 9.2-4.86a2.15 2.15 0 00.06-3 2.06 2.06 0 00-1-.59s-3.38-1-4-3.29a12 12 0 01-.42-4 7.3 7.3 0 015 1.28 6.34 6.34 0 012.1 3.88 2.14 2.14 0 002.91 1.78c3-1.14 8-2 9.5-.29 2.45 3 5.41 5.88 8 8.47 2.87 2.86 6.79 6.74 7.15 8.18-.7 1.61-2.99 4.33-3.95 4.46z" fill="#fff"/></svg>
                        
                            </div>
                            
                            <p>SMARTBOW can help you detect signs of illness early enough to avoid impact on milk production.</p>
                        
                        </slide>

                        <slide class="c-entry__slide">

                            <div class="c-entry__slide-img">

                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 137.1 97.49"><path data-name="Path 4027" d="M128.65 16.4c-2.55-2.53-5.42-5.39-7.75-8.18-3-3.54-8.79-2.59-12.06-1.69a9.77 9.77 0 00-3.13-4.34A11.66 11.66 0 0096.27.3a2.92 2.92 0 00-1.8 1.39c-1.13 1.93-.67 5.73-.09 7.81a8.42 8.42 0 003.56 4.66 9.48 9.48 0 01-4 1.7c-10.94.82-33.52 1-48.47 1.05-7 .05-12.44.08-15 .17-8.3.28-14.56 2.67-18.64 7.11A18.22 18.22 0 009.73 27C4.53 31.74-1.75 43 .55 56.76c.25 1.5.49 2.91.72 4.22C3.26 72.5 3.67 76 0 79.53l3 3.08c5.46-5.29 4.48-11 2.52-22.36q-.35-2-.72-4.2a31 31 0 011.91-16.9v1.17a98.73 98.73 0 004.8 24.73 248.31 248.31 0 01-.07 29.76 2.14 2.14 0 002 2.3 1 1 0 00.17 0h9.11a2.14 2.14 0 002.14-2l.14-3.26h6.49a2.13 2.13 0 002.14-2.11l.49-18.39a8.61 8.61 0 001.47 1.29 16.24 16.24 0 002 1.19s-.76 2-1.19 3 .48 1.53 1.43 2.2a2.11 2.11 0 002.72-.43 38.11 38.11 0 002.15-3.58h2.81s.33 2.48.43 3.82 1.48 1.67 2.53 1.67c1.28 0 1.86-.29 1.86-1.77s.19-3.57.19-3.57a7.36 7.36 0 002.19-.39 8.4 8.4 0 003-1.24l-5.77-3.62s-.48.57-2.67.85a14.21 14.21 0 01-8-1.67 20 20 0 01-5.59-4.24l.09-4.66a20.23 20.23 0 015.77 1 25.37 25.37 0 017.93 3.45C53.45 69 60.22 75.3 75.28 74c4.67-.42 10.77-.31 13.19 1.66a2.57 2.57 0 011 1.89c.5 6.2 1.14 17.85 1.14 18a2.14 2.14 0 002.14 2h6.8a2.15 2.15 0 002.14-2.13v-2.49c-.24-4-.23-8.16-.22-12.26v-1.3-4.09a24.84 24.84 0 01.93-6.06c.43-1.5 1-3.08 1.63-4.74 1.34-3.63 2.72-7.39 2.53-10.64a44.41 44.41 0 00-1.92-9.41 3.67 3.67 0 01.28-2.83q.39-.74.87-1.53c2-3.31 3.12-3.91 3.34-4 2 .08 16.28.65 20 .33s7.06-5.85 7.67-7.38c1.33-3.21-2.44-6.96-8.15-12.62zM29.33 87.58h-4.2L25.94 63a9.35 9.35 0 013.65-2.16zm99.47-55.45c-2.94.25-14.16-.12-19.68-.35h-.23c-2.15.13-4.26 2-6.63 5.87a51.25 51.25 0 00-2.49 4.69c0 .07 2.55 7 2.83 11.73.14 2.41-1.1 5.77-2.3 9-.61 1.66-1.25 3.37-1.72 5a33.89 33.89 0 00-1.08 10.8v.68l-.08 13.61h-2.64c-.2-3.65-.66-11.38-1-16a6.89 6.89 0 00-2.59-4.86c-4.59-3.73-13.71-3.15-16.4-2.86-12.6 1.34-18.8-4.62-25.35-9a28.82 28.82 0 00-7.8-3.56C28 52.51 22.32 60.25 22.1 60.57a2 2 0 00-.4 1.16l-1.07 31.1h-4.79a255.17 255.17 0 00-.08-28.34 1.87 1.87 0 00-.12-.58A95.68 95.68 0 0111 40.11a19.61 19.61 0 012.09-10.37l.1-.08A13.65 13.65 0 0115 27.07c3.28-3.56 8.54-5.49 15.64-5.73 2.46-.08 7.93-.12 14.84-.16 15-.1 37.68-.24 48.77-1.07 4.32-.33 8.71-4.4 9.2-4.86a2.15 2.15 0 00.06-3 2.06 2.06 0 00-1-.59s-3.38-1-4-3.29a12 12 0 01-.42-4 7.3 7.3 0 015 1.28 6.34 6.34 0 012.1 3.88 2.14 2.14 0 002.91 1.78c3-1.14 8-2 9.5-.29 2.45 3 5.41 5.88 8 8.47 2.87 2.86 6.79 6.74 7.15 8.18-.7 1.61-2.99 4.33-3.95 4.46z" fill="#fff"/></svg>
                        
                            </div>
                            
                            <p>Don’t lose 30 minutes looking for two cows. SMARTBOW monitors their location in real time.</p>
                        
                        </slide>

                        <slide class="c-entry__slide">

                            <div class="c-entry__slide-img">

                            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 137.1 97.49"><path data-name="Path 4027" d="M128.65 16.4c-2.55-2.53-5.42-5.39-7.75-8.18-3-3.54-8.79-2.59-12.06-1.69a9.77 9.77 0 00-3.13-4.34A11.66 11.66 0 0096.27.3a2.92 2.92 0 00-1.8 1.39c-1.13 1.93-.67 5.73-.09 7.81a8.42 8.42 0 003.56 4.66 9.48 9.48 0 01-4 1.7c-10.94.82-33.52 1-48.47 1.05-7 .05-12.44.08-15 .17-8.3.28-14.56 2.67-18.64 7.11A18.22 18.22 0 009.73 27C4.53 31.74-1.75 43 .55 56.76c.25 1.5.49 2.91.72 4.22C3.26 72.5 3.67 76 0 79.53l3 3.08c5.46-5.29 4.48-11 2.52-22.36q-.35-2-.72-4.2a31 31 0 011.91-16.9v1.17a98.73 98.73 0 004.8 24.73 248.31 248.31 0 01-.07 29.76 2.14 2.14 0 002 2.3 1 1 0 00.17 0h9.11a2.14 2.14 0 002.14-2l.14-3.26h6.49a2.13 2.13 0 002.14-2.11l.49-18.39a8.61 8.61 0 001.47 1.29 16.24 16.24 0 002 1.19s-.76 2-1.19 3 .48 1.53 1.43 2.2a2.11 2.11 0 002.72-.43 38.11 38.11 0 002.15-3.58h2.81s.33 2.48.43 3.82 1.48 1.67 2.53 1.67c1.28 0 1.86-.29 1.86-1.77s.19-3.57.19-3.57a7.36 7.36 0 002.19-.39 8.4 8.4 0 003-1.24l-5.77-3.62s-.48.57-2.67.85a14.21 14.21 0 01-8-1.67 20 20 0 01-5.59-4.24l.09-4.66a20.23 20.23 0 015.77 1 25.37 25.37 0 017.93 3.45C53.45 69 60.22 75.3 75.28 74c4.67-.42 10.77-.31 13.19 1.66a2.57 2.57 0 011 1.89c.5 6.2 1.14 17.85 1.14 18a2.14 2.14 0 002.14 2h6.8a2.15 2.15 0 002.14-2.13v-2.49c-.24-4-.23-8.16-.22-12.26v-1.3-4.09a24.84 24.84 0 01.93-6.06c.43-1.5 1-3.08 1.63-4.74 1.34-3.63 2.72-7.39 2.53-10.64a44.41 44.41 0 00-1.92-9.41 3.67 3.67 0 01.28-2.83q.39-.74.87-1.53c2-3.31 3.12-3.91 3.34-4 2 .08 16.28.65 20 .33s7.06-5.85 7.67-7.38c1.33-3.21-2.44-6.96-8.15-12.62zM29.33 87.58h-4.2L25.94 63a9.35 9.35 0 013.65-2.16zm99.47-55.45c-2.94.25-14.16-.12-19.68-.35h-.23c-2.15.13-4.26 2-6.63 5.87a51.25 51.25 0 00-2.49 4.69c0 .07 2.55 7 2.83 11.73.14 2.41-1.1 5.77-2.3 9-.61 1.66-1.25 3.37-1.72 5a33.89 33.89 0 00-1.08 10.8v.68l-.08 13.61h-2.64c-.2-3.65-.66-11.38-1-16a6.89 6.89 0 00-2.59-4.86c-4.59-3.73-13.71-3.15-16.4-2.86-12.6 1.34-18.8-4.62-25.35-9a28.82 28.82 0 00-7.8-3.56C28 52.51 22.32 60.25 22.1 60.57a2 2 0 00-.4 1.16l-1.07 31.1h-4.79a255.17 255.17 0 00-.08-28.34 1.87 1.87 0 00-.12-.58A95.68 95.68 0 0111 40.11a19.61 19.61 0 012.09-10.37l.1-.08A13.65 13.65 0 0115 27.07c3.28-3.56 8.54-5.49 15.64-5.73 2.46-.08 7.93-.12 14.84-.16 15-.1 37.68-.24 48.77-1.07 4.32-.33 8.71-4.4 9.2-4.86a2.15 2.15 0 00.06-3 2.06 2.06 0 00-1-.59s-3.38-1-4-3.29a12 12 0 01-.42-4 7.3 7.3 0 015 1.28 6.34 6.34 0 012.1 3.88 2.14 2.14 0 002.91 1.78c3-1.14 8-2 9.5-.29 2.45 3 5.41 5.88 8 8.47 2.87 2.86 6.79 6.74 7.15 8.18-.7 1.61-2.99 4.33-3.95 4.46z" fill="#fff"/></svg>
                        
                            </div>
                            
                            <p>Can’t be everywhere at once? With SMARTBOW, you can.</p>
                        
                        </slide>

                    </carousel>

                </div>

            </div>

        </div>
    
    </div>

</template>

<script>

import { Carousel, Slide } from 'vue-carousel';

export default {
    components: {
        Carousel,
        Slide
    },
    methods: {
        start() {
			this.$emit('start_experience', true)
		}
    }
}
</script>

<style lang="scss" scoped>

.c-entry {
    margin-bottom: 3rem;
    padding: 1rem 0 7rem;

    @include breakpoint(1000px) {
        margin-bottom: 5rem;
        padding: 0 0 5rem;
    }

    &__container {
        display: flex;
        flex-direction: column;

        @include breakpoint(1000px) {
            align-items: center;
            flex-direction: row;
            justify-content: space-between;
        }
    }

    &__content {
        text-align: center;

        @include breakpoint(1000px) {
            width: 55%;
        }

        .e-btn {

            @include breakpoint(large) {
                font-size: 1.5rem;
            }
        }

        h2 {
            @include breakpoint(medium) {
                font-size: 2.4rem;
            }

            @include breakpoint(large) {
                font-size: 2.7rem;
            }
        }

        p {
            margin-bottom: 3rem;

            @include breakpoint(medium) {
                font-size: 1.3rem;
            }
        }
    }

    &__slider-container {
        border-top: 1px solid rgba(255,255,255,0.2);
        margin-top: 2rem;
        padding-top: 2rem;

        @include breakpoint(1000px) {
            border-top: none;
            margin-top: 0;
            padding-top: 0;
            width: 40%;
        }
    }

    &__slider {
        background: rgba(0,0,0,0.6);
        padding: 1rem;
        text-align: center;

        @include breakpoint(medium) {
            border: 1px solid #6ABF4B;
            padding: 3rem;
        }
    }

    &__slider-head {
        color: #6ABF4B;
        font-size: 1.5rem;
    }

    &__slide {
        
        p {
            font-size: 1.2rem;
            margin: 0 auto;
            max-width: 80%;
        }
    }

    &__slide-img {
        align-items: center;
        border: 1px solid #6ABF4B;
        border-radius: 50%;
        display: flex;
        height: 150px;
        margin: 0 auto 1rem;
        justify-content: center;
        width: 150px;

        @include breakpoint(medium) {
            height: 200px;
            width: 200px;
        }

        svg {
            width: 50%;
        }
    }
    
}

.c-header,
.c-entry__content,
.c-entry__slider-container {
    opacity: 0;
    transition: opacity 0.3s ease-in;

    .loaded & {
        opacity: 1;
    }
}

.c-entry__content {
    transition-delay: 0.6s;
}

.c-entry__slider-container {
    transition-delay: 0.9s;
}

</style>
